import { DirectionEnum, isValidPositiveNumber } from "@ryde/shared";

export interface IRideStationDefaultSupplierPinInput {
  areaDefaultSupplierId?: number;
  skipSettingSupplierByAreaGroup?: boolean;
  supplierIdFromAreaGroupOnRide?: number;
  direction?: DirectionEnum;
  isFirstStation?: boolean;
  isLastStation?: boolean;
  useDestinationAreaForDirectionB?: boolean;
}

export interface IRideStationDefaultSupplierPinState {
  showDefaultSupplierPin: boolean;
  greyDefaultAreaMarkerForSkipWithoutPriorityId: boolean;
  isSupplierLookupStation: boolean;
}

/** Mirrors backend `resolveRideOriginAreaIdForAreaGroupDefault` anchor station selection. */
export const resolveIsSupplierLookupStationForAreaGroupDefault = ({
  direction,
  isFirstStation = false,
  isLastStation = false,
  useDestinationAreaForDirectionB = false,
}: Pick<
  IRideStationDefaultSupplierPinInput,
  | "direction"
  | "isFirstStation"
  | "isLastStation"
  | "useDestinationAreaForDirectionB"
>): boolean => {
  if (direction === DirectionEnum.DropOff && useDestinationAreaForDirectionB) {
    return isLastStation;
  }

  return isFirstStation;
};

/** Area-group default supplier pin is informational per station area; lookup anchor gets a distinct style. */
export const resolveRideStationDefaultSupplierPin = ({
  areaDefaultSupplierId,
  skipSettingSupplierByAreaGroup,
  supplierIdFromAreaGroupOnRide,
  direction,
  isFirstStation,
  isLastStation,
  useDestinationAreaForDirectionB,
}: IRideStationDefaultSupplierPinInput): IRideStationDefaultSupplierPinState => {
  const areaHasGroupDefaultSupplier = isValidPositiveNumber(
    areaDefaultSupplierId,
  );
  const greyDefaultAreaMarkerForSkipWithoutPriorityId =
    Boolean(skipSettingSupplierByAreaGroup) &&
    !isValidPositiveNumber(supplierIdFromAreaGroupOnRide);
  const isSupplierLookupStation =
    resolveIsSupplierLookupStationForAreaGroupDefault({
      direction,
      isFirstStation,
      isLastStation,
      useDestinationAreaForDirectionB,
    });

  return {
    showDefaultSupplierPin: areaHasGroupDefaultSupplier,
    greyDefaultAreaMarkerForSkipWithoutPriorityId,
    isSupplierLookupStation,
  };
};
